import { Button, FieldInput, Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { StyledWrapper } from 'styles/ContainerStyles';
import { isIos } from 'utils/deviceUtils';

const ContentWrapper = styled(StyledWrapper)`
  padding: 0 20px;
`;

const InputWrapper = styled(StyledWrapper)`
  margin: 24px 0 12px;
`;

const ButtonWrapper = styled(StyledWrapper)`
  margin-bottom: 12px;
`;

const ErrorContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
`;

const ErrorText = styled(Meta)`
  color: ${theme.colors.aimoUiRed};
  margin-left: 8px;
`;

export interface UnlockPmcBaseProps {
  unlockCode: string;
  errorMessage: string | null;
  loading: boolean;
  onUnlock: () => void;
  onCancel: () => void;
  onInputChange: (text: string) => void;
  description?: string;
  codeFieldTitle?: string;
  primaryButtonText?: string;
}

const UnlockPmcBase: React.FC<UnlockPmcBaseProps> = ({
  unlockCode,
  errorMessage,
  loading,
  onUnlock,
  onCancel,
  onInputChange,
  description,
  codeFieldTitle,
  primaryButtonText,
}) => {
  const { t } = useTranslation();

  return (
    <ContentWrapper mb={0}>
      <StyledWrapper mb={24} center>
        <Meta center color={theme.colors.gray300}>
          {description || t('permit.unlockPMC.description')}
        </Meta>
      </StyledWrapper>

      <InputWrapper>
        <FieldInput
          testID="unlock-code-input"
          title={codeFieldTitle || t('permit.unlockPMC.codePlaceholder')}
          value={unlockCode}
          onChangeText={onInputChange}
          returnKeyType="done"
          onSubmitEditing={onUnlock}
          isSheet={isIos}
        />
      </InputWrapper>

      {errorMessage && (
        <ErrorContainer>
          <Icon name="Info-Filled" color={theme.colors.aimoUiRed} size="m" />
          <ErrorText>{errorMessage}</ErrorText>
        </ErrorContainer>
      )}

      <ButtonWrapper>
        <Button
          testID="unlock-button"
          size="l"
          text={primaryButtonText || t('permit.unlockPMC.unlock')}
          onPress={onUnlock}
          disabled={!unlockCode || loading}
          loading={loading}
        />
      </ButtonWrapper>

      <ButtonWrapper mb={0}>
        <Button
          testID="cancel-button"
          size="l"
          buttonType="tertiary"
          text={t('button.cancel')}
          onPress={onCancel}
        />
      </ButtonWrapper>
    </ContentWrapper>
  );
};

export default UnlockPmcBase;
